import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Nullable } from 'src/types/nullable.type';
import { apiGetJourneyByAlias } from 'src/utils/journeyApi';
import { useDesktopLayout } from 'src/utils/use-desktop-layout.hook';
import { jDocToBlocks } from '../editor-store';
import { useNeueLayoutMode } from '../helpers/neue-layout-mode.hook';
import { JNode, Section } from '../types';
import { NeuePlayerDesktopView } from './desktop-view';
import { NeuePlayerMobileView } from './mobile-view';
import { usePlayerStore } from './player-store';

type Props = {
  uuid: string;
};

export const NeuePlayer = ({ uuid }: Props) => {
  const [loading, setLoading] = useState(true);
  const initEditor = usePlayerStore((state) => state.initEditor);
  const resetEditor = usePlayerStore((state) => state.resetEditor);
  const setLayoutMode = usePlayerStore((state) => state.setLayoutMode);
  const { layoutMode, isMobileLayout } = useNeueLayoutMode();
  const layoutReady = usePlayerStore((state) => state.layout.layoutReady);
  useEffect(() => {
    const initializeJourney = async (uuid: string) => {
      const journey = await apiGetJourneyByAlias(uuid);
      const jDoc: JNode = {
        type: { name: 'journey' },
        attributes: { id: '1' },
        content: (journey.steps?.[0].nodes || []).map((node: any) => {
          return {
            type: { name: 'section' },
            attributes: { id: node.uuid },
            content: (node?.node_blocks && JSON.parse(node.node_blocks)) || [],
          };
        }),
      };
      const sections = jDocToBlocks(jDoc);
      initEditor(sections);
    };
    if (uuid) {
      Promise.all([initializeJourney(uuid), new Promise((resolve) => setTimeout(resolve, 3000))]).then((_) => {
        setLoading(false);
      });
    }
    return () => {
      resetEditor();
    };
  }, [uuid]);

  useLayoutEffect(() => {
    setLayoutMode(layoutMode);
  }, [layoutMode]);

  return (
    <div className='w-full h-full relative'>
      <div className={classNames('w-full h-full flex transition-opacity', { 'opacity-0': loading })}>
        {isMobileLayout ? <NeuePlayerMobileView /> : <NeuePlayerDesktopView />}
      </div>
      <div
        className={classNames('absolute inset-0 flex items-center justify-center neue-text-editor transition-opacity', {
          'opacity-100': loading,
          'opacity-0 pointer-events-none': !loading,
        })}
      >
        <h1 className='animate-pulse text-center'>Loading your journey</h1>
      </div>
    </div>
  );
};
